import React from 'react';
import { siteMeta } from '../data/siteMeta';

function Header() {
  return (
    <header className="header">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <div className="flex items-start justify-between gap-4">
          <div className="flex-1">
            <h1 className="text-4xl font-bold gradient-text">
              Children's Privacy Laws Tracker
            </h1>
            <p className="mt-2 text-gray-600 max-w-2xl">
              The most comprehensive free database of children's online privacy and safety laws — 125+ laws across US federal, 40+ states, and 18 international jurisdictions. Covers COPPA, AADC, social media restrictions, age verification, AI chatbot safety, and more.
            </p>
            <div className="flex flex-wrap gap-2 mt-3">
              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-purple-100 text-purple-700 rounded-full text-xs font-semibold">
                <i className="fas fa-sync-alt text-xs"></i> {siteMeta.updateLabel} · {siteMeta.updatedOn}
              </span>
              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-green-100 text-green-700 rounded-full text-xs font-semibold">
                <i className="fas fa-check text-xs"></i> Free &amp; Public
              </span>
              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-blue-100 text-blue-700 rounded-full text-xs font-semibold">
                <i className="fas fa-globe text-xs"></i> US + 18 Jurisdictions
              </span>
              <span className="inline-flex items-center gap-1 px-2.5 py-1 bg-orange-100 text-orange-700 rounded-full text-xs font-semibold">
                <i className="fas fa-robot text-xs"></i> New: AI Chatbot Laws
              </span>
            </div>
          </div>
          <div className="text-right flex-shrink-0">
            <a href="https://cisomarketplace.com"
               className="text-purple-600 hover:text-purple-700 font-semibold text-sm"
               target="_blank"
               rel="noopener noreferrer">
              CISO Marketplace
            </a>
            <p className="text-xs text-gray-400 mt-1">Not legal advice</p>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
